export const ChangePointPage = () => {
    return <>ChangePointPage</>
}